module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/80/assets/images/0b3d9d1b1bcb30f2cfd2139af5f1ad99.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_progress.svg
// module id = lWAG
// module chunks = 0